import React from "react";


import GlassCard from "../../components/GlassCard";
import { footerPlatformContent } from "../data/footerPlatformContent";
import { useNavigate } from "react-router-dom";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import whitelogo from "../../images/white-logo.png"
import SocialLinks from "../../components/SocialLinks"

const Footer = ( {lang}) => {
  const navigate = useNavigate();
  const currentLang = useCurrentLang();

  const goHome = () => {
    navigate(`/${currentLang}`);
  };

  const goAbout = () => {
    navigate(`/${currentLang}/about-us`);
  };

  const goFAQs = () => {
    navigate(`/${currentLang}/faqs`)
  };
  const goContact = () => {
    navigate(`/${currentLang}/contact`)
  };



  const goSportsTherapy = () => {
    navigate(`/${currentLang}/sports-therapy`)
  };
  
  const goOurTeam = () => {
    navigate(`/${currentLang}/our-team`)
  };

  const goCareers = () => {
    navigate(`/${currentLang}/careers`)
  };
  
  const goBlog = () => {
    navigate(`/${currentLang}/blog`)
  };
  
  const goHelpCenter = () => {
    navigate(`/${currentLang}/help-center`)
  };
  
  const goPrivacyPolicy = () => {
    navigate(`/${currentLang}/privacy-policy`)
  };
  
  const goTermsOfService = () => {
    navigate(`/${currentLang}/terms-of-service`)
  };
    const goPlatform = () => {
    navigate(`/${currentLang}/platform`)
  };

  const goCookies = () => {
    navigate(`/${currentLang}/cookies`)
  };
  const goAccessibility = () => {
    navigate(`/${currentLang}/accessibility`)
  };
  const t = footerPlatformContent[currentLang]
  return (
    <footer style={{ padding: "80px 24px 40px" }}>
      <div className="container" style={{ maxWidth: 1120 }}>
        {/* Top brand + social */}
        <GlassCard
          style={{
            padding: "24px 28px",
            borderRadius: 28,
            marginBottom: 36,
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              gap: 16,
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "999px",
                  backgroundColor: "#176B87",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontWeight: 700,
                }}
              >
              <img src={whitelogo} alt="logo" className="logo" style={{
                width: 28,          
                height: 28,
                objectFit: "contain",
                display: "block",
              }} />
              </div>
              <div>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                  }}
                >
                  Revimo
                </div>
                <div
                  style={{
                    fontSize: 13,
                    color: "var(--text-muted)",
                  }}
                >
                {t.header}
                </div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 12 }}>
              <SocialLinks />
            </div>
          </div>
        </GlassCard>

        {/* Columns */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(150px, 1fr))",
            gap: 32,
            marginBottom: 40,
          }}
        >
          <div>
            <h4 style={{ marginTop: 0, marginBottom: 12 }}>{t.title1}</h4>
            <FooterLink onClick={goHome}>{t.home}</FooterLink>
            <FooterLink onClick={goSportsTherapy}>{t.store}</FooterLink>
            <FooterLink onClick={goPlatform}>{t.platform}</FooterLink>
          </div>

          <div>
            <h4 style={{ marginTop: 0, marginBottom: 12 }}>{t.title2}</h4>
            <FooterLink onClick={goAbout}>{t.aboutUs}</FooterLink>
            <FooterLink onClick={goOurTeam}>{t.ourTeam}</FooterLink>
            <FooterLink onClick={goCareers}>{t.careers}</FooterLink>
            <FooterLink onClick={goBlog}>{t.blog}</FooterLink>

          </div>

          <div>
            <h4 style={{ marginTop: 0, marginBottom: 12 }}>{t.title3}</h4>
            <FooterLink onClick={goFAQs}>{t.faqs}</FooterLink>
            <FooterLink onClick={goHelpCenter}>{t.helpCenter}</FooterLink>
            <FooterLink onClick={goContact}>{t.contactUs}</FooterLink>
            <FooterLink onClick={goPrivacyPolicy}>{t.privacyPolicy}</FooterLink>
            <FooterLink onClick={goTermsOfService}>{t.termsOfService}</FooterLink>
          </div>
        </div>


        {/* Bottom line */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            justifyContent: "space-between",
            fontSize: 12,
            color: "var(--text-muted)",
          }}
        >
          <span>{t.allRightsReserved}</span>
          <div style={{ display: "flex", gap: 16 }}>
            <FooterLink onClick={goPrivacyPolicy} style={{fontSize: "12px", color: "var(--text-muted)"}}>{t.privacy}</FooterLink>
            <FooterLink onClick={goTermsOfService} style={{fontSize: "12px", color: "var(--text-muted)"}}>{t.terms}</FooterLink>
            <FooterLink onClick={goCookies} style={{fontSize: "12px", color: "var(--text-muted)"}}>{t.cookies}</FooterLink>
            <FooterLink onClick={goAccessibility} style={{fontSize: "12px", color: "var(--text-muted)"}}>{t.accessibility}</FooterLink>
          </div>
        </div>
      </div>
    </footer>
  );
};
 
const FooterLink = ({ children,  ...props }) => {
  return (
    <button
      type="button"
      className="footer-link"
      style={{
        display: "block",
        padding: 0,
        marginBottom: 6,
        background: "none",
        fontSize: 14,
        border: "none",
        cursor: "pointer",
        color: "var(--text-muted)",
        textAlign: "left",
      }}
      {...props}
    >
      {children}
    </button>
  );
};
export default Footer;
